import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Button,
  Spinner,
  Label,
} from "reactstrap";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import axios from "axios";
import moment from "moment";

import Widget from "../../../components/Widget/Widget";
import "./chartStyles.css";

// taken from example here: https://codesandbox.io/s/highcharts-react-80g4yf?file=/demo.jsx:1004-3916
import dragPanes from "highcharts/modules/drag-panes";
import indicators from "highcharts/indicators/indicators";
import bollingerBands from "highcharts/indicators/bollinger-bands";
import ema from "highcharts/indicators/ema";
import annotationsAdvanced from "highcharts/modules/annotations-advanced";
import fullscreen from "highcharts/modules/full-screen";
import priceIndicator from "highcharts/modules/price-indicator";
import stockTools from "highcharts/modules/stock-tools";
import accessibility from "highcharts/modules/accessibility";

dragPanes(Highcharts);
indicators(Highcharts);
bollingerBands(Highcharts);
ema(Highcharts);
annotationsAdvanced(Highcharts);
fullscreen(Highcharts);
priceIndicator(Highcharts);
stockTools(Highcharts);
accessibility(Highcharts);

function addPopupEvents(chart) {
  var closePopupButtons = document.getElementsByClassName(
    "highcharts-close-popup"
  );
  // Close popup button:
  Highcharts.addEvent(closePopupButtons[0], "click", function () {
    this.parentNode.style.display = "none";
  });

  Highcharts.addEvent(closePopupButtons[1], "click", function () {
    this.parentNode.style.display = "none";
  });

  // Add an indicator from popup
  Highcharts.addEvent(
    document.querySelectorAll(".highcharts-popup-indicators button")[0],
    "click",
    function () {
      var typeSelect = document.querySelectorAll(
          ".highcharts-popup-indicators select"
        )[0],
        type = typeSelect.options[typeSelect.selectedIndex].value,
        period =
          document.querySelectorAll(".highcharts-popup-indicators input")[0]
            .value || 14;

      chart.addSeries({
        linkedTo: "aapl-ohlc",
        type: type,
        params: {
          period: parseInt(period, 10),
        },
      });

      chart.stockToolbar.indicatorsPopupContainer.style.display = "none";
    }
  );

  // Update an annotaiton from popup
  Highcharts.addEvent(
    document.querySelectorAll(".highcharts-popup-annotations button")[0],
    "click",
    function () {
      var strokeWidth = parseInt(
          document.querySelectorAll(
            '.highcharts-popup-annotations input[name="stroke-width"]'
          )[0].value,
          10
        ),
        strokeColor = document.querySelectorAll(
          '.highcharts-popup-annotations input[name="stroke"]'
        )[0].value;

      // Stock/advanced annotations have common options under typeOptions
      if (chart.currentAnnotation.options.typeOptions) {
        chart.currentAnnotation.update({
          typeOptions: {
            lineColor: strokeColor,
            lineWidth: strokeWidth,
            line: {
              strokeWidth: strokeWidth,
              stroke: strokeColor,
            },
            background: {
              strokeWidth: strokeWidth,
              stroke: strokeColor,
            },
            innerBackground: {
              strokeWidth: strokeWidth,
              stroke: strokeColor,
            },
            outerBackground: {
              strokeWidth: strokeWidth,
              stroke: strokeColor,
            },
            connector: {
              strokeWidth: strokeWidth,
              stroke: strokeColor,
            },
          },
        });
      } else {
        // Basic annotations:
        chart.currentAnnotation.update({
          shapes: [
            {
              "stroke-width": strokeWidth,
              stroke: strokeColor,
            },
          ],
          labels: [
            {
              borderWidth: strokeWidth,
              borderColor: strokeColor,
            },
          ],
        });
      }
      chart.stockToolbar.annotationsPopupContainer.style.display = "none";
    }
  );
}
// end of taken from example

export default function PeriodAverage() {
  const [refreshing, setRefreshing] = useState(true);
  const [data, setData] = useState([
    {
      name: "",
      data: [[0]],
    },
  ]);
  const [endPicker1, setEndPicker1] = useState(new Date());
  const [startPicker1, setStartPicker1] = useState(
    moment().subtract(1, "day").toDate()
  );
  const [days1, setDays1] = useState("");
  const [periodType1, setPeriodType1] = useState("");

  const [endPicker2, setEndPicker2] = useState(new Date());
  const [startPicker2, setStartPicker2] = useState(
    moment().subtract(1, "day").toDate()
  );
  const [days2, setDays2] = useState("");
  const [periodType2, setPeriodType2] = useState("");

  const [endPicker3, setEndPicker3] = useState(new Date());
  const [startPicker3, setStartPicker3] = useState(
    moment().subtract(1, "day").toDate()
  );
  const [days3, setDays3] = useState("");
  const [periodType3, setPeriodType3] = useState("");

  const [endPicker4, setEndPicker4] = useState(new Date());
  const [startPicker4, setStartPicker4] = useState(
    moment().subtract(1, "day").toDate()
  );
  const [days4, setDays4] = useState("");
  const [periodType4, setPeriodType4] = useState("");

  const [endPicker5, setEndPicker5] = useState(new Date());
  const [startPicker5, setStartPicker5] = useState(
    moment().subtract(1, "day").toDate()
  );
  const [days5, setDays5] = useState("");
  const [periodType5, setPeriodType5] = useState("");

  const [visibleLines, setVisibleLines] = useState(1);

  const addGroup = () => {
    if (visibleLines < 5) {
      setVisibleLines(visibleLines + 1);
    }
  };

  const removeGroup = () => {
    if (visibleLines > 1) {
      setVisibleLines(visibleLines - 1);
    }
  };

  const fetchData = async () => {
    let requestValue = "";
    requestValue += `${moment(startPicker1).format("YYYYMMDD")}-${moment(endPicker1).format("YYYYMMDD")}-${days1}-${periodType1}`;

    if (visibleLines >= 2) {
      requestValue += `_${moment(startPicker2).format("YYYYMMDD")}-${moment(endPicker2).format("YYYYMMDD")}-${days2}-${periodType2}`;
    }
    if (visibleLines >= 3) {
      requestValue += `_${moment(startPicker3).format("YYYYMMDD")}-${moment(endPicker3).format("YYYYMMDD")}-${days3}-${periodType3}`;
    }
    if (visibleLines >= 4) {
      requestValue += `_${moment(startPicker4).format("YYYYMMDD")}-${moment(endPicker4).format("YYYYMMDD")}-${days4}-${periodType4}`;
    }
    if (visibleLines >= 5) {
      requestValue += `_${moment(startPicker5).format("YYYYMMDD")}-${moment(endPicker5).format("YYYYMMDD")}-${days5}-${periodType5}`;
    }
    setRefreshing(true);
    const response = await axios.get(
      `/buildings/periodaverage/${requestValue}`
    );
    if (response.status === 200) {
      setData(response.data);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const timeData = {
    chart: {
      type: "line",
      events: {
        // this is taken from example
        load: function () {
          addPopupEvents(this);
        },
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: [
        "0000",
        "0030",
        "0100",
        "0130",
        "0200",
        "0230",
        "0300",
        "0330",
        "0400",
        "0430",
        "0500",
        "0530",
        "0600",
        "0630",
        "0700",
        "0730",
        "0800",
        "0830",
        "0900",
        "0930",
        "1000",
        "1030",
        "1100",
        "1130",
        "1200",
        "1230",
        "1300",
        "1330",
        "1400",
        "1430",
        "1500",
        "1530",
        "1600",
        "1630",
        "1700",
        "1730",
        "1800",
        "1830",
        "1900",
        "1930",
        "2000",
        "2030",
        "2100",
        "2130",
        "2200",
        "2230",
        "2300",
        "2330",
      ],
      title: {
        text: undefined,
      },
    },
    yAxis: {
      title: {
        text: undefined,
      },
      min: 0,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
      },
    },

    colors: ["#95d0fc", "#2F33A7", "#00A5FF", "#4d53e0", "#6b859e"],
    series: data,

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            plotOptions: {
              series: {
                marker: {
                  radius: 2.5,
                },
              },
            },
          },
        },
      ],
    },
    stockTools: {
      gui: {
        enabled: false,
      },
    },
    navigationBindings: {
      // this is taken from example
      events: {
        selectButton: function (event) {
          var newClassName = event.button.className + " highcharts-active",
            topButton = event.button.parentNode.parentNode;

          if (topButton.classList.contains("right")) {
            newClassName += " right";
          }

          // If this is a button with sub buttons,
          // change main icon to the current one:
          if (!topButton.classList.contains("highcharts-menu-wrapper")) {
            topButton.className = newClassName;
          }

          // Store info about active button:
          this.chart.activeButton = event.button;
        },
        deselectButton: function (event) {
          event.button.parentNode.parentNode.classList.remove(
            "highcharts-active"
          );

          // Remove info about active button:
          this.chart.activeButton = null;
        },
        showPopup: function (event) {
          if (!this.indicatorsPopupContainer) {
            this.indicatorsPopupContainer = document.getElementsByClassName(
              "highcharts-popup-indicators"
            )[0];
          }

          if (!this.annotationsPopupContainer) {
            this.annotationsPopupContainer = document.getElementsByClassName(
              "highcharts-popup-annotations"
            )[0];
          }

          if (event.formType === "indicators") {
            this.indicatorsPopupContainer.style.display = "block";
          } else if (event.formType === "annotation-toolbar") {
            // If user is still adding an annotation, don't show popup:
            if (!this.chart.activeButton) {
              this.chart.currentAnnotation = event.annotation;
              this.annotationsPopupContainer.style.display = "block";
            }
          }
        },
        closePopup: function () {
          this.indicatorsPopupContainer.style.display = "none";
          this.annotationsPopupContainer.style.display = "none";
        },
      },
    },
  };

  return (
    <Widget className="charts-tabs-widget" style={{ overflow: "auto" }}>
      <TabContent activeTab={1}>
        <TabPane tabId={1}>
          <Col>
            <Row className="mb-4">
              <Col xs={12} lg={12}>
                <Widget>
                  <div className="headline-2 mb-4">
                    Period Average{" "}
                    {refreshing ? (
                      <Spinner size="sm" className="mr-3">
                        Loading...
                      </Spinner>
                    ) : null}
                  </div>
                  <Row className="mb-4">
                    <Col xs={12} sm={6} md={3} className="mb-2">
                      <Label for="days1" className="form-label">
                        Days
                      </Label>
                      <select
                        name="days1"
                        id="days1"
                        value={days1}
                        onChange={(event) => setDays1(event.target.value)}
                        className="form-select"
                      >
                        <option value=""></option>
                        <option value="Single">Single</option>
                        <option value="Multiple">Multiple</option>
                      </select>
                    </Col>
                    <Col xs={12} sm={6} md={3} className="mb-2">
                      <Label for="type1" className="form-label">
                        Type
                      </Label>
                      <select
                        name="type1"
                        id="type1"
                        value={periodType1}
                        onChange={(event) => setPeriodType1(event.target.value)}
                        className="form-select"
                      >
                        <option value=""></option>
                        <option value="contingencyReservePrice">CONRESA</option>
                        <option value="uniformSingaporeEnergyPrice">USEP</option>
                        <option value="counterfactualUniformSingaporeEnergyPrice">
                          CUSEP
                        </option>
                        <option value="loadCurtailmentPrice">LCP</option>
                        <option value="totalLoadMW">Total Load</option>
                        <option value="totalCurtailedLoad">TCL</option>
                      </select>
                    </Col>
                    <Col xs={12} sm={6} md={3} className="mb-2">
                      <Label for="startDate1" className="form-label">
                        From
                      </Label>
                      <Flatpickr
                        id="startDate1"
                        name="startDate1"
                        className="form-control"
                        onChange={(date) => {
                          setStartPicker1(date[0]);
                        }}
                        value={startPicker1}
                      />
                    </Col>
                    <Col xs={12} sm={6} md={3} className="mb-2">
                      <Label for="endDate1" className="form-label">
                        To
                      </Label>
                      <Flatpickr
                        id="endDate1"
                        name="endDate1"
                        className="form-control"
                        onChange={(date) => setEndPicker1(date[0])}
                        value={endPicker1}
                      />
                    </Col>
                  </Row>
                  {visibleLines >= 2 ? (
                    <Row className="mb-4">
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="days2" className="form-label">
                          Days
                        </Label>
                        <select
                          name="days2"
                          id="days2"
                          value={days2}
                          onChange={(event) => setDays2(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="Single">Single</option>
                          <option value="Multiple">Multiple</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="type2" className="form-label">
                          Type
                        </Label>
                        <select
                          name="type2"
                          id="type2"
                          value={periodType2}
                          onChange={(event) => setPeriodType2(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="contingencyReservePrice">CONRESA</option>
                          <option value="uniformSingaporeEnergyPrice">
                            USEP
                          </option>
                          <option value="counterfactualUniformSingaporeEnergyPrice">
                            CUSEP
                          </option>
                          <option value="loadCurtailmentPrice">LCP</option>
                          <option value="totalLoadMW">Total Load</option>
                          <option value="totalCurtailedLoad">TCL</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="startDate2" className="form-label">
                          From
                        </Label>
                        <Flatpickr
                          id="startDate2"
                          name="startDate2"
                          className="form-control"
                          onChange={(date) => {
                            setStartPicker2(date[0]);
                          }}
                          value={startPicker2}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="endDate2" className="form-label">
                          To
                        </Label>
                        <Flatpickr
                          id="endDate2"
                          name="endDate2"
                          className="form-control"
                          onChange={(date) => setEndPicker2(date[0])}
                          value={endPicker2}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {visibleLines >= 3 ? (
                    <Row className="mb-4">
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="days3" className="form-label">
                          Days
                        </Label>
                        <select
                          name="days3"
                          id="days3"
                          value={days3}
                          onChange={(event) => setDays3(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="Single">Single</option>
                          <option value="Multiple">Multiple</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="type3" className="form-label">
                          Type
                        </Label>
                        <select
                          name="type3"
                          id="type3"
                          value={periodType3}
                          onChange={(event) => setPeriodType3(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="contingencyReservePrice">CONRESA</option>
                          <option value="uniformSingaporeEnergyPrice">
                            USEP
                          </option>
                          <option value="counterfactualUniformSingaporeEnergyPrice">
                            CUSEP
                          </option>
                          <option value="loadCurtailmentPrice">LCP</option>
                          <option value="totalLoadMW">Total Load</option>
                          <option value="totalCurtailedLoad">TCL</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="startDate3" className="form-label">
                          From
                        </Label>
                        <Flatpickr
                          id="startDate3"
                          name="startDate3"
                          className="form-control"
                          onChange={(date) => {
                            setStartPicker3(date[0]);
                          }}
                          value={startPicker3}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="endDate3" className="form-label">
                          To
                        </Label>
                        <Flatpickr
                          id="endDate3"
                          name="endDate3"
                          className="form-control"
                          onChange={(date) => setEndPicker3(date[0])}
                          value={endPicker3}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {visibleLines >= 4 ? (
                    <Row className="mb-4">
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="days4" className="form-label">
                          Days
                        </Label>
                        <select
                          name="days4"
                          id="days4"
                          value={days4}
                          onChange={(event) => setDays4(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="Single">Single</option>
                          <option value="Multiple">Multiple</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="type4" className="form-label">
                          Type
                        </Label>
                        <select
                          name="type4"
                          id="type4"
                          value={periodType4}
                          onChange={(event) => setPeriodType4(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="contingencyReservePrice">CONRESA</option>
                          <option value="uniformSingaporeEnergyPrice">
                            USEP
                          </option>
                          <option value="counterfactualUniformSingaporeEnergyPrice">
                            CUSEP
                          </option>
                          <option value="loadCurtailmentPrice">LCP</option>
                          <option value="totalLoadMW">Total Load</option>
                          <option value="totalCurtailedLoad">TCL</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="startDate4" className="form-label">
                          From
                        </Label>
                        <Flatpickr
                          id="startDate4"
                          name="startDate4"
                          className="form-control"
                          onChange={(date) => {
                            setStartPicker4(date[0]);
                          }}
                          value={startPicker4}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="endDate4" className="form-label">
                          To
                        </Label>
                        <Flatpickr
                          id="endDate4"
                          name="endDate4"
                          className="form-control"
                          onChange={(date) => setEndPicker4(date[0])}
                          value={endPicker4}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {visibleLines >= 5 ? (
                    <Row className="mb-4">
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="days5" className="form-label">
                          Days
                        </Label>
                        <select
                          name="days5"
                          id="days5"
                          value={days5}
                          onChange={(event) => setDays5(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="Single">Single</option>
                          <option value="Multiple">Multiple</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="type5" className="form-label">
                          Type
                        </Label>
                        <select
                          name="type5"
                          id="type5"
                          value={periodType5}
                          onChange={(event) => setPeriodType5(event.target.value)}
                          className="form-select"
                        >
                          <option value=""></option>
                          <option value="contingencyReservePrice">CONRESA</option>
                          <option value="uniformSingaporeEnergyPrice">
                            USEP
                          </option>
                          <option value="counterfactualUniformSingaporeEnergyPrice">
                            CUSEP
                          </option>
                          <option value="loadCurtailmentPrice">LCP</option>
                          <option value="totalLoadMW">Total Load</option>
                          <option value="totalCurtailedLoad">TCL</option>
                        </select>
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="startDate5" className="form-label">
                          From
                        </Label>
                        <Flatpickr
                          id="startDate5"
                          name="startDate5"
                          className="form-control"
                          onChange={(date) => {
                            setStartPicker5(date[0]);
                          }}
                          value={startPicker5}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={3} className="mb-2">
                        <Label for="endDate5" className="form-label">
                          To
                        </Label>
                        <Flatpickr
                          id="endDate5"
                          name="endDate5"
                          className="form-control"
                          onChange={(date) => setEndPicker5(date[0])}
                          value={endPicker5}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Row className="mb-4">
                    <Col xs="auto">
                      <Button
                        className="btn-rounded m-3"
                        color={visibleLines === 5 ? "danger" : "info"}
                        disabled={visibleLines === 5}
                        onClick={addGroup}
                      >
                        <span className="align-middle">+</span>
                      </Button>
                    </Col>
                    <Col xs="auto">
                      <Button
                        className="btn-rounded m-3"
                        color={visibleLines === 1 ? "danger" : "info"}
                        disabled={visibleLines === 1}
                        onClick={removeGroup}
                      >
                        <span className="align-middle">-</span>
                      </Button>
                    </Col>
                    <Col xs="auto">
                      <Button
                        className="btn-rounded m-3"
                        color="primary"
                        onClick={fetchData}
                      >
                        <span className="align-middle">Submit</span>
                      </Button>
                    </Col>
                  </Row>
                  {/* this is taken from example */}
                  <div
                    className="chart-wrapper"
                    // className={s.rechartsBlock}
                  >
                    <div className="highcharts-popup highcharts-popup-indicators">
                      <span className="highcharts-close-popup">&times;</span>
                      <div className="highcharts-popup-wrapper">
                        <label htmlFor="indicator-list">Indicator</label>
                        <select name="indicator-list">
                          <option value="sma">SMA</option>
                          <option value="ema">EMA</option>
                          <option value="bb">Bollinger bands</option>
                        </select>
                        <label htmlFor="stroke">Period</label>
                        <input type="text" name="period" value="14" />
                      </div>
                      <button>Add</button>
                    </div>
                    <div className="highcharts-popup highcharts-popup-annotations">
                      <span className="highcharts-close-popup">&times;</span>
                      <div className="highcharts-popup-wrapper">
                        <label htmlFor="stroke">Color</label>
                        <input type="text" name="stroke" />
                        <label htmlFor="stroke-width">Width</label>
                        <input type="text" name="stroke-width" />
                      </div>
                      <button>Save</button>
                    </div>
                    <div className="highcharts-stocktools-wrapper highcharts-bindings-container highcharts-bindings-wrapper">
                      <div className="highcharts-menu-wrapper">
                        <ul className="highcharts-stocktools-toolbar stocktools-toolbar">
                          {/* <li className="highcharts-indicators" title="Indicators">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">Indicators</span>
                          </li> */}
                          <li
                            className="highcharts-label-annotation"
                            title="Simple shapes"
                          >
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Shapes
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li
                                className="highcharts-label-annotation"
                                title="Label"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Label
                                </span>
                              </li>
                              <li
                                className="highcharts-circle-annotation"
                                title="Circle"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Circle
                                </span>
                              </li>
                              <li
                                className="highcharts-rectangle-annotation "
                                title="Rectangle"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Rectangle
                                </span>
                              </li>
                              <li
                                className="highcharts-ellipse-annotation"
                                title="Ellipse"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Ellipse
                                </span>
                              </li>
                            </ul>
                          </li>
                          <li className="highcharts-segment" title="Lines">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Lines
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li className="highcharts-segment" title="Segment">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Segment
                                </span>
                              </li>
                              <li
                                className="highcharts-arrow-segment"
                                title="Arrow segment"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Arrow segment
                                </span>
                              </li>
                              <li className="highcharts-ray" title="Ray">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Ray
                                </span>
                              </li>
                              <li
                                className="highcharts-arrow-ray"
                                title="Arrow ray"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Arrow ray
                                </span>
                              </li>
                              <li className="highcharts-infinity-line" title="Line">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Line
                                </span>
                              </li>
                              <li
                                className="highcharts-arrow-infinity-line"
                                title="Arrow line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Arrow
                                </span>
                              </li>
                              <li
                                className="highcharts-horizontal-line"
                                title="Horizontal line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Horizontal
                                </span>
                              </li>
                              <li
                                className="highcharts-vertical-line"
                                title="Vertical line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Vertical
                                </span>
                              </li>
                            </ul>
                          </li>
                          <li className="highcharts-elliott3" title="Crooked lines">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Crooked lines
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li
                                className="highcharts-elliott3"
                                title="Elliott 3 line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Elliot 3
                                </span>
                              </li>
                              <li
                                className="highcharts-elliott5"
                                title="Elliott 5 line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Elliot 5
                                </span>
                              </li>
                              <li
                                className="highcharts-crooked3"
                                title="Crooked 3 line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Crooked 3
                                </span>
                              </li>
                              <li
                                className="highcharts-crooked5"
                                title="Crooked 5 line"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Crooked 5
                                </span>
                              </li>
                            </ul>
                          </li>
                          <li className="highcharts-measure-xy" title="Measure">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Measure
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li
                                className="highcharts-measure-xy"
                                title="Measure XY"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Measure XY
                                </span>
                              </li>
                              <li
                                className="highcharts-measure-x"
                                title="Measure X"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Measure X
                                </span>
                              </li>
                              <li
                                className="highcharts-measure-y"
                                title="Measure Y"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Measure Y
                                </span>
                              </li>
                            </ul>
                          </li>
                          <li className="highcharts-fibonacci" title="Advanced">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Advanced
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li
                                className="highcharts-fibonacci"
                                title="Fibonacci"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Fibonacci
                                </span>
                              </li>
                              <li
                                className="highcharts-pitchfork"
                                title="Pitchfork"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Pitchfork
                                </span>
                              </li>
                              <li
                                className="highcharts-parallel-channel"
                                title="Parallel channel"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Parallel channel
                                </span>
                              </li>
                            </ul>
                          </li>
                          <li
                            className="highcharts-vertical-counter"
                            title="Vertical labels"
                          >
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Counters
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li
                                className="highcharts-vertical-counter"
                                title="Vertical counter"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Counter
                                </span>
                              </li>
                              <li
                                className="highcharts-vertical-label"
                                title="Vertical label"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Label
                                </span>
                              </li>
                              <li
                                className="highcharts-vertical-arrow"
                                title="Vertical arrow"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Arrow
                                </span>
                              </li>
                            </ul>
                          </li>
                          <li className="highcharts-flag-circlepin" title="Flags">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">
                              Flags
                            </span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li
                                className="highcharts-flag-circlepin"
                                title="Flag circle"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Circle
                                </span>
                              </li>
                              <li
                                className="highcharts-flag-diamondpin"
                                title="Flag diamond"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Diamond
                                </span>
                              </li>
                              <li
                                className="highcharts-flag-squarepin"
                                title="Flag square"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Square
                                </span>
                              </li>
                              <li
                                className="highcharts-flag-simplepin"
                                title="Flag simple"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">
                                  Simple
                                </span>
                              </li>
                            </ul>
                          </li>
                          {/* <li className="highcharts-series-type-ohlc" title="Type change">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-menu-item-title">Series type</span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li className="highcharts-series-type-ohlc" title="OHLC">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">OHLC</span>
                              </li>
                              <li className="highcharts-series-type-line" title="Line">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">Line</span>
                              </li>
                              <li
                                className="highcharts-series-type-candlestick"
                                title="Candlestick"
                              >
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">Candlestick</span>
                              </li>
                            </ul>
                          </li> */}
                          {/* <li className="highcharts-save-chart right" title="Save chart">
                            <span className="highcharts-menu-item-btn"></span>
                          </li> */}
                          <li
                            className="highcharts-full-screen right"
                            title="Fullscreen"
                          >
                            <span className="highcharts-menu-item-btn"></span>
                          </li>
                          {/* <li className="highcharts-zoom-x right" title="Zoom change">
                            <span className="highcharts-menu-item-btn"></span>
                            <span className="highcharts-submenu-item-arrow highcharts-arrow-right"></span>
                            <ul className="highcharts-submenu-wrapper">
                              <li className="highcharts-zoom-x" title="Zoom X">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">Zoom X</span>
                              </li>
                              <li className="highcharts-zoom-y" title="Zoom Y">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">Zoom Y</span>
                              </li>
                              <li className="highcharts-zoom-xy" title="Zooom XY">
                                <span className="highcharts-menu-item-btn"></span>
                                <span className="highcharts-menu-item-title">Zoom XY</span>
                              </li>
                            </ul>
                          </li> */}
                          {/* <li
                            className="highcharts-current-price-indicator right"
                            title="Current Price Indicators"
                          >
                            <span className="highcharts-menu-item-btn"></span>
                          </li>
                          <li
                            className="highcharts-toggle-annotations right"
                            title="Toggle annotations"
                          >
                            <span className="highcharts-menu-item-btn"></span>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                    {/* </Row> */}
                    <HighchartsReact
                      containerProps={{ className: "chart" }}
                      highcharts={Highcharts}
                      options={timeData}
                    />
                  </div>
                </Widget>
              </Col>
            </Row>
          </Col>
        </TabPane>
      </TabContent>
    </Widget>
  );
}
